import { PromoteMaterialAliasReq } from '../../../shared/dto/ReqDtoRepository';
import { useApiWrapper } from '../../../shared/hooks/useApi/apiWrapper';
import {
  assignMaterialAliasSet,
  deleteMaterialAlias,
  getMaterialAliasList,
  getMaterialAliasSetList,
  promoteMaterialAlias,
} from '../api/adminApi';
import { useAdminMaterialAliasStore } from '../store/adminMaterialAliasStore';
import {
  MaterialAliasSortOrder,
  SortDirection,
} from '../../../shared/enum/EnumRepository';
import { useTempAlertStore } from '../../../shared/store/portal/tempAlertStore';

export const useAdminMaterialAlias = () => {
  const store = useAdminMaterialAliasStore();
  const withApiHandler = useApiWrapper();
  const setDeletedTempAlert = useTempAlertStore(
    (state) => state.setDeletedTempAlert,
  );

  const load = async (
    page = 1,
    unassignedOnly = store.unassignedOnly,
    size = Number(store.pageSize),
    sortDirection: SortDirection = store.sortDirection,
    sortField: MaterialAliasSortOrder = store.sortField,
  ) => {
    await withApiHandler(async () => {
      const [aliasResponse, aliasSetResponse] = await Promise.all([
        getMaterialAliasList(
          page,
          unassignedOnly,
          size,
          sortField,
          sortDirection,
        ),
        getMaterialAliasSetList(),
      ]);
      store.setAliasList(aliasResponse.data.content);
      store.setPagination(aliasResponse.data.page, aliasResponse.data.totalPages);
      store.setAliasSetList(aliasSetResponse.data);
    }, [
      'get-material-alias',
      page,
      unassignedOnly,
      size,
      sortField,
      sortDirection,
    ]);
  };

  const promote = async (aliasId: string, data: PromoteMaterialAliasReq) => {
    await withApiHandler(async () => {
      const response = await promoteMaterialAlias(aliasId, data);
      store.replaceAlias(response.data);
      if (response.data.aliasSet) {
        store.setAliasSetList([...store.aliasSetList, response.data.aliasSet]);
      }
    }, ['promote-material-alias', aliasId]);
  };

  const assign = async (aliasId: string, aliasSetId: string) => {
    await withApiHandler(async () => {
      const response = await assignMaterialAliasSet(aliasId, aliasSetId);
      store.replaceAlias(response.data);
    }, ['assign-material-alias', aliasId, aliasSetId]);
  };

  const remove = async (aliasId: string) => {
    let deleted = false;
    await withApiHandler(async () => {
      await deleteMaterialAlias(aliasId);
      store.removeAlias(aliasId);
      setDeletedTempAlert();
      deleted = true;
    }, ['delete-material-alias', aliasId]);
    return deleted;
  };

  return {
    ...store,
    load,
    promote,
    assign,
    remove,
  };
};
